<script>
import PlayButton from './PlayButton';
import '../filters';

export default {
  name: 'AudioTrackSelect',
  props: {
    tracks: Array,
    currentTrack: Object,
    currentTime: Number
  },
  components: {
    PlayButton
  },
  computed: {
    inactiveTracks() {
      return this.tracks.filter(track => {
        return track.slug !== this.currentTrack.slug;
      });
    },
  },
  methods: {
    onSelect(trackId) {
      this.$emit('trackSelected', trackId);
    }
  }
};
</script>

<template>
  <div class="track-select">
    <div class="track-select__inner">
      <h2 class="track-select__title">{{ currentTime*1000 | formatTime }} – {{ currentTrack.title }}</h2>
      <div class="track-select__tracks">
        <span class="track-select__track"
          v-for="track in inactiveTracks"
          :key="track.slug"
          v-bind:class="{ 'track-select__track--active': track.slug === currentTrack.slug }"
          v-on:click="onSelect(track.slug)">
            {{ track.title }}
        </span>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '../assets/styles/variables';

.track-select {
  position: relative;
  margin: 0 auto;
  width: 100%;

  &__inner {
    position: relative;
    width: 600px;
    margin: 0 auto;
  }
}

.track-select__title {
  display: block;
  font-size: 2rem;
  margin: 0;
  margin-right: 2rem;
  background-color: var(--color-main);
  color: var(--dark);
  height: 5.3125rem;
  line-height: 5.2rem;
  width: 100%;
  text-align: center;
}

.track-select__tracks {
  display: flex;
  position: absolute;
  bottom: 0;
  right: -2rem;
}

.track-select__track {
  display: block;
  white-space: nowrap;
  cursor: pointer;
  font-size: 1.5rem;
  background-color: var(--light);
  padding: .5rem 1.5rem;
  margin: 0 .75rem;
  transform: translate(1rem, 80%);
}

</style>
